import React from 'react';
import ContentLoader from 'react-content-loader';
import styles from './SportPlaceholder.module.scss';

const SportPlaceholder = props => {
    return (
        <div
            className={styles.container}
            style={{
                backgroundColor: 'var(--color-background-primary)',
            }}
        >
            <ContentLoader speed={2} viewBox='0 0 235 50' className={styles.loaderContainer}>
                <circle cx='10' cy='20' r='8' />
                <rect x='25' y='15' rx='5' ry='5' width='220' height='10' />
            </ContentLoader>
        </div>
    );
};

export default SportPlaceholder;
